export default {"src":"/_next/static/media/zm.c5d42009.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};